export default __webpack_public_path__ + "static/media/Rodmell.ceb4516b.jpg";